import { CommonClient } from './api-common';
import { FreshdeskClient } from './api-freshdesk';
import { CasesApiClient } from '@@/products/cases/api/cases-api-client';

export class CommonApiClient {
  private _commonClient: CommonClient | undefined;
  private _freshdeskClient: FreshdeskClient | undefined;
  private _casesClient: CasesApiClient | undefined;

  public get common() {
    if (!this._commonClient) {
      this._commonClient = new CommonClient();
    }

    return this._commonClient;
  }

  public get freshdesk() {
    if (!this._freshdeskClient) {
      this._freshdeskClient = new FreshdeskClient();
    }

    return this._freshdeskClient;
  }

  public get cases() {
    if (!this._casesClient) {
      this._casesClient = new CasesApiClient();
    }

    return this._casesClient;
  }
}
